// src/components/ProtectedRoute.js
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { getRefreshToken } from "../utils/auth";
import { FilterProvider } from "../context/FilterContext";

const ProtectedRoute = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const hasRefreshToken = getRefreshToken();

  useEffect(() => {
    console.log("ProtectedRoute", isAuthenticated);
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    // Logic to recreate the component or handle unauthenticated state
    return <Navigate to="/login" replace />;
  }

  return hasRefreshToken ? (
    <FilterProvider>
      <Outlet />
    </FilterProvider>
  ) : (
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoute;
